import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomQuestionsComponent, UpdateQuestionOutput } from '../../components/entities/custom-questions.component';
import { AppSurvey, SurveySubmission, SurveySubmissionData } from 'globals/store/app.data';
import { PublicService } from 'src/app/services/public.service';
import { ActionButtonComponent } from 'src/app/components/nav-bar/action-button.component';
import { MutatingInputComponent } from 'src/app/components/joi-input/mutating-input.component';
import { CommonModule } from '@angular/common';

const createSurveySubmission = (name: string = null, email: string = null): SurveySubmission => 
  ({ customQuestions: {}, name, email })
@Component({
    selector: 'survey',
    template: `
<ng-container *ngIf="!!useNameEmail">
  <mutating-input [object]="surveySubmission" [prop]="'name'" [placeholder]="'Your name...'"></mutating-input>
  <mutating-input [object]="surveySubmission" [prop]="'email'" [placeholder]="'Your email...'"></mutating-input>
</ng-container>
<custom-questions *ngIf="survey?.customQuestions.length"
  [entity]="surveySubmission"
  [questions]="survey.customQuestions"
  [showMandatoryWarnings]="showMandatoryWarnings"
  [shareView]="true"
  (updateQuestion)="updateCustomQuestion($event)"
></custom-questions>
<action-button [text]="'SUBMIT'" [disabled]="!addedAnswer || disabled" (click)="addedAnswer ? submit() : null"></action-button>
`,
    styles: [`
  action-button { margin-top: 20px; }  
`],
    standalone: true,
    imports: [ActionButtonComponent, CustomQuestionsComponent, MutatingInputComponent, CommonModule],
})
export class SurveyComponent implements OnInit {
  @Input() survey: AppSurvey
  @Input() appId: string
  @Input() eventId: string
  @Input() useNameEmail: boolean
  @Input() defaultName: string
  @Input() defaultEmail: string
  showMandatoryWarnings = false;

  @Output() submitSurvey: EventEmitter<SurveySubmissionData> = new EventEmitter()
  @Input() disabled: boolean = false

  surveySubmission: SurveySubmission
  addedAnswer = false

  constructor(private publicService: PublicService){

  }

  ngOnInit() {
    this.createSubmission()
  }

  createSubmission() {
    this.surveySubmission = this.useNameEmail ? createSurveySubmission(this.defaultName, this.defaultEmail) : createSurveySubmission()
  }

  async submit() {
    console.log("SHOULD BE SUBMITTING!!")
      // CHECK FOR MANDATORY FIELDS
      const allRequirementsCompleted = await this.publicService.checkForMandatory(this.survey.customQuestions, this.survey.customQuestions);
      if(!allRequirementsCompleted) {
        this.showMandatoryWarnings = true;
        return;
      }
    this.submitSurvey.emit({
      submission: this.surveySubmission,
      eventId: this.eventId,
      appId: this.appId,
      surveyId: this.survey.id
    })
    this.addedAnswer = false
    this.createSubmission()
  }
  

  updateCustomQuestion(data: UpdateQuestionOutput) {
    const { id, answer } = data
    this.surveySubmission.customQuestions[id] = answer
    this.addedAnswer = true
  }
  
}



